import CheckoutProductLocationForm from './CheckoutProductLocationForm'

export default CheckoutProductLocationForm
